// extracted by mini-css-extract-plugin
export default {"signup":"styles_signup__i1fKP","card":"styles_card__EflWa","inputs":"styles_inputs__Z4FFR","submitButton":"styles_submitButton__yI3r7"};